import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Linkify } from '@/components/Linkify/Linkify';
import { isArabic } from '@/config/constants';
import { useMarkdownToHtml } from '@/hooks/useMarkdownToHtml';
import styles from './Message.module.scss';
export const Text = ({ message, event, onClick }) => {
    var _a;
    const text = message ? message.text : ((_a = event.body) === null || _a === void 0 ? void 0 : _a.text) || event.text || '';
    const { html } = useMarkdownToHtml(text);
    const containerRef = useRef(null);
    useEffect(() => {
        if (!onClick || !containerRef.current) {
            return;
        }
        const handleLinkClick = (e) => {
            const target = e.target;
            if (target.tagName === 'A') {
                onClick({
                    type: 'url',
                    label: target.textContent || target.getAttribute('href') || '',
                    value: target.getAttribute('href') || '',
                });
            }
        };
        const container = containerRef.current;
        container.addEventListener('click', handleLinkClick);
        return () => container.removeEventListener('click', handleLinkClick);
    }, [onClick]);
    return (_jsx("span", { className: styles.text, dir: isArabic(text), ref: containerRef, children: _jsx(Linkify, { children: html }) }));
};
